var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.6887 13.1246H18.3762V16.9531C18.3762 19.6672 16.6098 21.8754 14.4387 21.8754C12.2676 21.8754 10.5012 19.6672 10.5012 16.9531V8.63988L6.95202 11.3061C5.89655 12.0923 5.25124 13.5211 5.25124 15.0525V18.2862L0.876246 21.4447C0.0395285 22.0463 -0.250315 23.3862 0.236403 24.4322L4.61139 33.9076C5.09264 34.9536 6.16452 35.3091 7.00123 34.7075L12.6559 30.6261H20.1262C22.0567 30.6261 23.6262 28.664 23.6262 26.2507H24.5012C25.4692 26.2507 26.2512 25.2731 26.2512 24.0631V19.6877H26.6887C27.416 19.6877 28.0012 18.9562 28.0012 18.0469V14.7654C28.0012 13.8561 27.416 13.1246 26.6887 13.1246ZM34.766 10.5678L30.391 1.09236C29.9098 0.0463767 28.8379 -0.309122 28.0012 0.292491L22.3465 4.37389H16.7575C16.1012 4.37389 15.4614 4.60633 14.9036 5.03703L13.0715 6.46586C12.5575 6.86238 12.2512 7.56654 12.2512 8.31856V16.9531C12.2512 18.4639 13.2301 19.6877 14.4387 19.6877C15.6473 19.6877 16.6262 18.4639 16.6262 16.9531V10.9369H26.6887C28.3785 10.9369 29.7512 12.6529 29.7512 14.7654V16.7138L34.1262 13.5553C34.9629 12.9469 35.2473 11.6138 34.766 10.5678Z",
    fill: "#3EC1D3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHand);
export default __webpack_public_path__ + "static/media/hand.37b04c3efe2999e80c0cfd4ae06315b9.svg";
export { ForwardRef as ReactComponent };